---
title: Refund Policy
published_time: 2024-08-11T14:30:00Z
og:
  title: Refund Policy
  description: EasyPageGo's refund policy.
---

# Refund Policy for EasyPageGo by L13o S.r.l

**Last updated: 2024-08-11**

Thank you for choosing EasyPageGo by L13o S.r.l (“L13o S.r.l,” “We,” “Us,” or “Our”). We strive to provide you with a high-quality software application. However, if you are not completely satisfied with your purchase, we offer a 14-day money-back guarantee.

## Eligibility for a Refund

To be eligible for a refund, you must meet the following conditions:

- Your purchase of EasyPageGo must have been made directly through our official website or authorized sales channels.
- Your refund request must be submitted within 14 days from the date of purchase.
- If you live, you can provide a reason for your refund request, however, this is not required. If you do, we will use this information to improve our Software and will be grateful for your feedback.
- If your purchase included any bundled products or services, these items must also be returned or deactivated as part of the refund process.

## How to Request a Refund

To request a refund, please follow these steps:

1. Contact us via e-mail at the following address: [hello@l13o.com](mailto:hello@l13o.com).
2. To make things easier, please use the same e-mail address that you used to purchase EasyPageGo.
3. Wait for our response. We will review your request and get back to you as soon as possible.

## Refund Process

On our side, the following steps will be taken:

- We will refund the full purchase amount to the original payment method used for the purchase.
- Refunds will be processed within 7 days, but it may take additional time for the refund to appear in your account, depending on your payment provider.

## Exclusions

We reserve the right to refuse a refund request in the following situations:

- If the refund request is made after the 14-day refund period has expired.
- If the Software has been used in a way that violates our End User License Agreement (EULA).
- If the Software was purchased through an unauthorized reseller or distributor.

## Contact Us

If you have any questions or concerns about our Refund Policy or need assistance with a refund request, please contact our customer support team via email at [hello@l13o.com](mailto:hello@l13o.com).

## Governing Law

This Refund Policy is governed by and construed in accordance with the laws of Italy, without regard to its conflict of law principles.

By using EasyPageGo, you acknowledge and agree to the terms of this Refund Policy, including the 14-day money-back guarantee. If you do not agree to these terms, please do not use the Software.
